import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, Input, Select } from 'antd';
import { connect } from 'dva';
import BottomActions from './BottomActions';
import styles from '../styles.less';

const FormItem = Form.Item;

function OutreachInformation({ intl, form, data, agentsList, onSubmit, goPrevStep }) {
  const findAgentById = (id) => {
    return agentsList.find(p => p.id === id);
  };

  const [isAgentChanged, setIsAgentChanged] = useState(false);
  const [agent, setAgent] = useState(findAgentById(data.outreach_email_agent_id));
  const { getFieldDecorator } = form;

  const getFieldsValues = () => {
    const values = form.getFieldsValue();
    if (!('url_fields_value' in values) || !Array.isArray(values.url_fields_value)) {
      values.url_fields_value = [];
    }
    return values;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    form.validateFields((err) => {
      if (!err) {
        onSubmit(getFieldsValues());
      }
    });
  };

  const filterOption = (inputValue, option) => {
    return option.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
  };

  const goBack = () => {
    goPrevStep(getFieldsValues());
  };

  useEffect(() => {
    const newAgent = findAgentById(form.getFieldValue('outreach_email_agent_id'));
    const prevId = agent ? +agent.id : null;
    const newId = newAgent ? +newAgent.id : null;
    if (prevId !== newId) {
      setIsAgentChanged(true);
      if (form.getFieldValue('url_fields_value')) {
        const newValues = {};
        form.getFieldValue('url_fields_value').forEach((value, index) => {
          newValues[`url_fields_value[${index}]`] = '';
        });
        form.setFieldsValue(newValues);
      }
    }
    setAgent(newAgent);
  }, [form.getFieldValue('outreach_email_agent_id')]);

  return (
    <Form onSubmit={handleSubmit}>

      {/* Agent */}
      <FormItem
        className={styles.formItem}
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.AgentLabel" />}
      >
        {getFieldDecorator('outreach_email_agent_id', {
          initialValue: data.outreach_email_agent_id,
          rules: [{
            required: true,
            message: intl.formatMessage({ id: 'Common.Field.Required' }),
          }],
        })(
          <Select
            showSearch
            showArrow
            filterOption={filterOption}
          >
            {agentsList.map((c) => {
              return (
                <Select.Option
                  key={c.id}
                  value={c.id}
                  title={c.name}
                >
                  {c.name}
                </Select.Option>
              );
            })}
          </Select>,
        )}
      </FormItem>

      {agent && (
        <React.Fragment key={agent.id}>
          {agent.url_fields.map((field, index) => (
            <FormItem
              key={index}
              label={field}
              className={styles.formItem}
            >
              {form.getFieldDecorator(`url_fields_value[${index}]`, {
                initialValue: data.url_fields_value && !isAgentChanged ? data.url_fields_value[index] || '' : '',
                rules: [
                  {
                    type: 'url',
                    message: intl.formatMessage({ id: 'Component.CreateHubspotTask.Form.Validation.URL.Value' }),
                  },
                ],
              })(
                <Input
                  maxLength={1000}
                  type="text"
                />,
              )}
            </FormItem>
          ))}
        </React.Fragment>
      )}

      <BottomActions goBack={goBack} backSuffix={'Back'} nextSuffix={'Next'} />
    </Form>
  );
}

OutreachInformation.propTypes = {
  data: PropTypes.object,
  agentsList: PropTypes.array,
  onSubmit: PropTypes.func,
  goPrevStep: PropTypes.func,
};

export default connect()(injectIntl(Form.create()(injectIntl(OutreachInformation))));



// WEBPACK FOOTER //
// ./src/components/Leads/Hubspot/CreateHubspotTransferModal/components/OutreachInformation.js